import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";

interface Props
{
    count: number | string;
    align?: string;
}

import './Counter.scss';

export default class Counter extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    render() : JSX.Element
    {
        const {count, align='left'} = this.props;

        if (! count) return null;

        return <span styleName={`${align}-align`}>

            {count}

        </span>
    }
}



// WEBPACK FOOTER //
// ./src/ts/app/common/counter/Counter.tsx